import TopicListView, { QueryType } from '../topic-list-view/TopicListView.sync'
import { TopicInfo } from '../topic-list-view/TopicListItemView.sync'

export interface RecentlyActiveTopicsProps {
  tab: string
  requestUrl: string
  query: QueryType
  attachmentCdn: string
  topics: TopicInfo[]
}

const RecentlyActiveTopics = (props: RecentlyActiveTopicsProps) => (
  <div className='box widget box__content qa-widget-recent-topics topic-list-view'>
    <TopicListView {...props} />
  </div>
)

export default RecentlyActiveTopics
